<template>
  <v-container class="conselhos-comissoes">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        icon="mdi-pencil-box-outline"
        main="Gestão"
        sub="Conselhos, Comissões e Diretorias do Executivo"
        home='/gestao-admin'
      />
      <div>
        <formulario />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Formulario from '../components/conselhos/index.vue'
export default {
  name: 'ConselhosComissoes',
  components: { PageTitle, Formulario },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
